import { Banner, BlockStack, ChoiceList, Select, Text, TextField } from "@shopify/polaris";

import type { SurveySource } from "../api/me";
import { SURVEY_SOURCE_OPTIONS } from "../hooks/useSurveyForm";

import { t } from "../lib/i18n";

type Props = {
  source: SurveySource | null;
  onSourceChange: (source: SurveySource) => void;
  showsPartnerPicker: boolean;
  showsOtherSourceInput?: boolean;
  isOtherPartner: boolean;
  partner: string;
  onPartnerChange: (value: string) => void;
  partnerOptions: Array<{ label: string; value: string }>;
  otherReferrer: string;
  onOtherReferrerChange: (value: string) => void;
  isError: boolean;
};

/** 初回起動アンケートの設問一式（流入元 + 条件付き紹介元）。表示先を問わない純粋な UI。 */
export function SurveyQuestionFields({
  source,
  onSourceChange,
  showsPartnerPicker,
  showsOtherSourceInput = false,
  isOtherPartner,
  partner,
  onPartnerChange,
  partnerOptions,
  otherReferrer,
  onOtherReferrerChange,
  isError,
}: Props) {
  return (
    <BlockStack gap="400">
      <Text as="p" tone="subdued">
        {t("今後の改善のため、1問だけご回答ください。")}
      </Text>
      <ChoiceList
        title={t("流入元")}
        titleHidden
        choices={SURVEY_SOURCE_OPTIONS.map((o) => ({ ...o, label: t(o.label) }))}
        selected={source ? [source] : []}
        onChange={(selected) => onSourceChange(selected[0] as SurveySource)}
      />
      {showsPartnerPicker && (
        <Select
          label={t("紹介元")}
          options={partnerOptions}
          value={partner}
          onChange={onPartnerChange}
        />
      )}
      {showsPartnerPicker && isOtherPartner && (
        <TextField
          label={
            source === "blog"
              ? t("ブログ・記事・ニュース・SNS名")
              : t("紹介元のお名前・会社名")
          }
          value={otherReferrer}
          onChange={onOtherReferrerChange}
          autoComplete="off"
          maxLength={255}
        />
      )}
      {showsOtherSourceInput && (
        <TextField
          label={t("どこで知りましたか？")}
          value={otherReferrer}
          onChange={onOtherReferrerChange}
          autoComplete="off"
          maxLength={255}
        />
      )}
      {isError && (
        <Banner tone="critical">
          {t("送信に失敗しました。お手数ですがもう一度お試しください。")}
        </Banner>
      )}
    </BlockStack>
  );
}
